export const GLI_LINK = "https://www.assuragents.com/r/L5wuOCPYUz";
export const PNO_LINK = "https://www.assuragents.com/r/XcjYkAa7Cb";
export const SDU_LINK =
  "https://parcours-souscription-sdu.insured.fr/?cxa=THOM1275698";
export const PJ_LINK = "https://www.assuragents.com/r/PR6fUwQlkH";
